import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=670e536b&scoped=true&"
import script from "./firstStep.vue?vue&type=script&lang=js&"
export * from "./firstStep.vue?vue&type=script&lang=js&"
import style0 from "./firstStep.vue?vue&type=style&index=0&id=670e536b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e536b",
  null
  
)

export default component.exports